module.exports = __webpack_public_path__ + "static/img/tiktok_black.7dbe0c0d.png";